module.exports = __webpack_public_path__ + "static/artist-management-banner-a8460b98cf9d19cd04ff766c7d00aa9d.webp";